/* Trident header behavior (sections/header-trident.liquid).
   Extracted from the section's inline <script> so it is CDN-cached across
   pages. Loaded with `defer` from the section; initTridentHeader is
   idempotent and boots via the immediate scan + DOMContentLoaded fallback
   below, same as when it was inline. */
(function () {
  function initTridentHeader(root) {
    if (!root || root.__tfInit) return;
    root.__tfInit = true;

    var drawer = root.querySelector('[data-tf-drawer]');
    var body = document.body;

    // ---- Deferred menu panels ----
    // The Travel + Sale megas and all drawer sub-panels are not in the page
    // HTML (they cost ~265ms of Liquid and ~110KB per page). They arrive from
    // /pages/tf-header-panels?sections=<section id>, which renders this same
    // section in "panels mode" (see RENDER MODES in header-trident.liquid),
    // and are moved into .tf-nav / .tf-drawer__body. Fetched on the first
    // pointer/touch/focus on the header, or when the page goes idle after
    // load, whichever is first; cached per session in sessionStorage. In the
    // theme editor the section renders everything inline and sets
    // data-tf-panels-inline, so nothing is fetched.
    // root is the #tf-header div; the section id + panel attributes live on
    // the enclosing <section data-section-id> (the Section Rendering API id).
    var sectionEl = root.closest('[data-section-id]') || root;
    var panelsUrl = sectionEl.getAttribute('data-tf-panels-url');
    var panelsDone = sectionEl.hasAttribute('data-tf-panels-inline');
    var panelsPromise = null;
    var navImagesHydrated = false;
    function panelsPending() { return !panelsDone; }
    function injectPanels(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var tpl = doc.querySelector('template[data-tf-panels]');
      if (!tpl) throw new Error('no panels');
      var frag = document.importNode(tpl.content, true);
      var nav = root.querySelector('.tf-nav');
      var drawerBody = drawer && drawer.querySelector('.tf-drawer__body');
      var megas = frag.querySelector('[data-tf-panels-megas]');
      var sub = frag.querySelector('[data-tf-panels-drawer]');
      var extra = frag.querySelector('[data-tf-panels-extra]');
      if (megas && nav) { while (megas.firstChild) nav.appendChild(megas.firstChild); }
      if (sub && drawerBody) { while (sub.firstChild) drawerBody.appendChild(sub.firstChild); }
      if (extra) { var host = root.querySelector('[data-tf-header]') || root; while (extra.firstChild) host.appendChild(extra.firstChild); }
      panelsDone = true;
      if (navImagesHydrated) hydrateNavImages();
    }
    function loadPanels() {
      if (panelsDone) return Promise.resolve();
      if (panelsPromise) return panelsPromise;
      var sid = sectionEl.getAttribute('data-section-id');
      if (!panelsUrl || !sid) { panelsDone = true; return Promise.resolve(); }
      var key = 'tf-panels:' + sid + ':' + (sectionEl.getAttribute('data-tf-panels-key') || '');
      var cached = null;
      try { cached = window.sessionStorage.getItem(key); } catch (_) {}
      var source = cached ? Promise.resolve(cached) :
        fetch(panelsUrl + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (json) {
            var html = json[sid] || '';
            if (!html) throw new Error('empty');
            try { window.sessionStorage.setItem(key, html); } catch (_) {}
            return html;
          });
      panelsPromise = source.then(injectPanels).catch(function () { panelsPromise = null; });
      return panelsPromise;
    }
    function schedulePanels() {
      if (panelsDone) return;
      var go = function () { loadPanels(); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 5000 });
      else setTimeout(go, 2500);
    }
    if (document.readyState === 'complete') schedulePanels();
    else window.addEventListener('load', schedulePanels, { once: true });

    // Hard body lock: overflow:hidden + overscroll-behavior alone don't stop
    // iOS from scrolling the page when a drawer panel has nothing to scroll
    // itself. position:fixed with a compensating top offset makes the page
    // physically unscrollable without a visual jump.
    var lockedScrollY = 0;
    function lockBody() {
      lockedScrollY = window.scrollY;
      body.style.position = 'fixed';
      body.style.top = -lockedScrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.classList.add('tf-no-scroll');
    }
    function unlockBody() {
      body.classList.remove('tf-no-scroll');
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      window.scrollTo(0, lockedScrollY);
    }

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      var burger = root.querySelector('[data-tf-open-drawer]');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      lockBody();
    }
    var drillStack = [];
    function resetDrill() {
      var drawerBody = drawer.querySelector('.tf-drawer__body');
      if (!drawerBody) return;
      drawerBody.classList.remove('is-drilled');
      drawerBody.querySelectorAll('.tf-drill--sub').forEach(function (p) { p.classList.remove('is-active'); p.classList.remove('is-behind'); });
      drillStack = [];
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      var burger = root.querySelector('[data-tf-open-drawer]');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      unlockBody();
      resetDrill();
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-tf-open-drawer]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-tf-close-drawer]')) { e.preventDefault(); closeDrawer(); return; }
      var drillBtn = e.target.closest('[data-tf-drill-into]');
      if (drillBtn) {
        var idx = drillBtn.getAttribute('data-tf-drill-into');
        var drawerBody = drawer.querySelector('.tf-drawer__body');
        var subPanel = drawer.querySelector('[data-tf-drill-panel="' + idx + '"]');
        if (!subPanel && panelsPending()) {
          // sub-panels not fetched yet: load, then replay the tap
          drillBtn.classList.add('is-loading');
          loadPanels().then(function () {
            drillBtn.classList.remove('is-loading');
            if (drawer.classList.contains('is-open') && drawer.querySelector('[data-tf-drill-panel="' + idx + '"]')) drillBtn.click();
          });
          return;
        }
        if (drawerBody && subPanel) {
          if (drillStack.length) drillStack[drillStack.length - 1].classList.add('is-behind');
          subPanel.classList.add('is-active');
          subPanel.scrollTop = 0;
          drillStack.push(subPanel);
          drawerBody.classList.add('is-drilled');
          hydrateLazyGrids(subPanel);
        }
        return;
      }
      if (e.target.closest('[data-tf-drill-back]')) {
        var backBody = drawer.querySelector('.tf-drawer__body');
        var current = drillStack.pop();
        if (current) current.classList.remove('is-active');
        if (drillStack.length) { drillStack[drillStack.length - 1].classList.remove('is-behind'); }
        else if (backBody) { backBody.classList.remove('is-drilled'); }
        return;
      }
    });

    // Travel mega: switch tab content on hover / keyboard focus
    function activateTravelTab(tab) {
      var rail = tab.parentNode;
      var travel = tab.closest('.tf-travel');
      var i = tab.getAttribute('data-i');
      rail.querySelectorAll('.tf-travel__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      if (travel) travel.querySelectorAll('.tf-travel__panel').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-i') === i); });
    }
    root.addEventListener('mouseover', function (e) { var t = e.target.closest('[data-tf-travel-tab]'); if (t) activateTravelTab(t); });
    root.addEventListener('focusin', function (e) { var t = e.target.closest('[data-tf-travel-tab]'); if (t) activateTravelTab(t); });

    // Sale tabs: preview panel on hover / keyboard focus; click follows the
    // tab's link to its collection (tabs are anchors).
    function activateSaleTab(tab) {
      var t = tab.getAttribute('data-sale-tab');
      root.querySelectorAll('.tf-sale__tab').forEach(function (b) { b.classList.toggle('is-active', b === tab); });
      root.querySelectorAll('.tf-sale__panel').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-sale-panel') === t); });
    }
    root.addEventListener('mouseover', function (e) { var t = e.target.closest('[data-sale-tab]'); if (t) activateSaleTab(t); });
    root.addEventListener('focusin', function (e) { var t = e.target.closest('[data-sale-tab]'); if (t) activateSaleTab(t); });

    // ---- Mega panel open/close ----
    // Panels live AFTER the nav <ul> (all labels parse/paint together instead
    // of streaming between ~90KB panel chunks), so the old pure-CSS
    // `li:hover > .tf-mega` can't reach them. Replicate it: 100ms hover-intent
    // delay on open, instant close, hovering the open panel keeps it open,
    // keyboard focus opens/closes, Escape closes.
    (function () {
      var nav = root.querySelector('.tf-nav');
      if (!nav) return;
      var openTimer = null, currentLi = null, currentPanel = null;
      function panelFor(li) {
        var k = li.getAttribute('data-tf-mega-for');
        return k ? nav.querySelector('.tf-mega[data-tf-mega="' + k + '"]') : null;
      }
      function closeMega() {
        if (openTimer) { clearTimeout(openTimer); openTimer = null; }
        if (currentPanel) currentPanel.classList.remove('is-open');
        if (currentLi) currentLi.classList.remove('is-mega-open');
        currentPanel = null; currentLi = null;
      }
      function openMega(li) {
        var p = panelFor(li);
        closeMega();
        if (!p) return;
        p.classList.add('is-open');
        li.classList.add('is-mega-open');
        currentPanel = p; currentLi = li;
        hydrateSalePanels(p);
        hydrateLazyGrids(p);
      }
      nav.addEventListener('mouseover', function (e) {
        var li = e.target.closest('.tf-nav__item');
        if (!li) return; // over the open panel or nav chrome: leave state alone
        if (openTimer) { clearTimeout(openTimer); openTimer = null; }
        if (li === currentLi) return;
        if (!panelFor(li)) {
          closeMega();
          if (li.hasAttribute('data-tf-mega-deferred') && panelsPending()) {
            loadPanels().then(function () { if (li.matches(':hover') && panelFor(li)) openMega(li); });
          }
          return;
        }
        openTimer = setTimeout(function () { openTimer = null; openMega(li); }, 100);
      });
      nav.addEventListener('mouseleave', closeMega);
      nav.addEventListener('focusin', function (e) {
        var li = e.target.closest('.tf-nav__item');
        if (li) {
          if (panelFor(li)) openMega(li);
          else {
            closeMega();
            if (li.hasAttribute('data-tf-mega-deferred') && panelsPending()) {
              loadPanels().then(function () { if (li.contains(document.activeElement) && panelFor(li)) openMega(li); });
            }
          }
        }
        // focus moving into the panel itself keeps it open
      });
      nav.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || !nav.contains(e.relatedTarget)) closeMega();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMega();
      });
    })();

    // ---- Lazy sale-panel grids ----
    // Only the active sale tab's product grid is server-rendered (the other
    // ~14 tabs were most of the header's 2.3s server render). When the Sale
    // mega opens, fill the placeholder panels from the public
    // /collections/<handle>/products.json endpoint, mirroring
    // snippets/trident-feature-grid.liquid's card markup.
    function money(v) {
      var n = parseFloat(v);
      return isNaN(n) ? '' : '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function saleCard(p) {
      var minV = (p.variants || []).reduce(function (a, v) {
        return (!a || parseFloat(v.price) < parseFloat(a.price)) ? v : a;
      }, null) || { price: '0' };
      var onSale = minV.compare_at_price && parseFloat(minV.compare_at_price) > parseFloat(minV.price);
      var a = document.createElement('a');
      a.className = 'tf-feature__card';
      a.href = '/products/' + p.handle;
      var imgWrap = document.createElement('span');
      imgWrap.className = 'tf-feature__img';
      if (p.images && p.images[0]) {
        var img = document.createElement('img');
        var src = p.images[0].src;
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=360';
        img.width = 300; img.height = 300; img.loading = 'lazy';
        img.alt = p.title;
        imgWrap.appendChild(img);
      }
      if (onSale) {
        var badge = document.createElement('span');
        badge.className = 'tf-feature__sale'; badge.textContent = 'SALE';
        imgWrap.appendChild(badge);
      }
      var info = document.createElement('span');
      info.className = 'tf-feature__info';
      var name = document.createElement('span');
      name.className = 'tf-feature__name'; name.textContent = p.title;
      var prices = document.createElement('span');
      prices.className = 'tf-feature__prices';
      var price = document.createElement('span');
      price.className = 'tf-feature__price' + (onSale ? ' tf-feature__price--sale' : '');
      price.textContent = money(minV.price);
      prices.appendChild(price);
      if (onSale) {
        var oldP = document.createElement('span');
        oldP.className = 'tf-feature__old'; oldP.textContent = money(minV.compare_at_price);
        prices.appendChild(oldP);
      }
      info.appendChild(name); info.appendChild(prices);
      a.appendChild(imgWrap); a.appendChild(info);
      return a;
    }
    function viewAllCard(url) {
      var a = document.createElement('a');
      a.className = 'tf-feature__card tf-feature__card--view-all';
      a.href = url;
      a.innerHTML = '<span class="tf-feature__img"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg></span><span class="tf-feature__info"><span class="tf-feature__name">View All</span></span>';
      return a;
    }
    function hydrateSalePanels(scope) {
      (scope || root).querySelectorAll('[data-tf-lazy-coll]').forEach(function (panel) {
        if (panel.__tfLoading) return;
        panel.__tfLoading = true;
        var coll = panel.getAttribute('data-tf-lazy-coll');
        var count = parseInt(panel.getAttribute('data-tf-lazy-count') || '10', 10);
        var viewAll = panel.getAttribute('data-tf-lazy-viewall') === '1';
        var url = panel.getAttribute('data-tf-lazy-url') || ('/collections/' + coll);
        var limit = viewAll ? Math.max(count - 1, 1) : count;
        fetch('/collections/' + coll + '/products.json?limit=' + limit, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var grid = document.createElement('div');
            grid.className = 'tf-feature__grid';
            grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(150px, 1fr))';
            (data.products || []).forEach(function (p) { grid.appendChild(saleCard(p)); });
            if (viewAll) grid.appendChild(viewAllCard(url));
            panel.appendChild(grid);
            panel.removeAttribute('data-tf-lazy-coll');
          })
          .catch(function () { panel.__tfLoading = false; });
      });
    }

    // ---- Lazy feature grids + search picks ----
    // Rendering these inline cost ~0.7s of header Liquid on every page (TTFB).
    // They now render on demand through the Section Rendering API
    // (sections/tf-lazy-grid.liquid, tf-lazy-pick.liquid) using the same
    // snippets, so the dropped-variant filter and pick rules are unchanged.
    function fetchSection(handle, sectionId) {
      return fetch('/collections/' + encodeURIComponent(handle) + '?section_id=' + sectionId, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    function adoptCard(card) {
      card.querySelectorAll('img[data-tf-src]').forEach(function (img) {
        img.src = img.getAttribute('data-tf-src');
        img.removeAttribute('data-tf-src');
      });
      return document.importNode(card, true);
    }
    function hydrateLazyGrids(scope) {
      (scope || root).querySelectorAll('[data-tf-lazy-grid]').forEach(function (grid) {
        if (grid.__tfLoading) return;
        grid.__tfLoading = true;
        var count = parseInt(grid.getAttribute('data-count') || '4', 10);
        var viewAll = grid.getAttribute('data-viewall') === '1';
        var photo = grid.getAttribute('data-photo') === '1';
        var limit = viewAll ? Math.max(count - 1, 1) : count;
        function dropEmptyGrid() {
          // the shell no longer checks collections[].products_count server-side,
          // so an empty or missing collection is handled here instead
          var col = grid.closest('.tf-feature');
          if (col) col.remove(); else grid.remove();
        }
        fetchSection(grid.getAttribute('data-tf-lazy-grid'), 'tf-lazy-grid').then(function (doc) {
          var cards = doc.querySelectorAll('.tf-feature__card:not(.tf-feature__card--view-all)');
          var added = 0;
          for (var i = 0; i < cards.length && i < limit; i++) {
            var card = adoptCard(cards[i]);
            if (photo) card.classList.add('tf-feature__card--photo');
            grid.appendChild(card);
            added++;
          }
          if (!added) { dropEmptyGrid(); return; }
          if (viewAll) grid.appendChild(viewAllCard(grid.getAttribute('data-url')));
          grid.removeAttribute('data-tf-lazy-grid');
        }).catch(function (err) {
          if (err && err.message === '404') { dropEmptyGrid(); return; }
          grid.__tfLoading = false;
        });
      });
    }
    function hydrateLazyPicks(scope) {
      (scope || root).querySelectorAll('[data-tf-lazy-pick]').forEach(function (slot) {
        if (slot.__tfLoading) return;
        slot.__tfLoading = true;
        fetchSection(slot.getAttribute('data-tf-lazy-pick'), 'tf-lazy-pick').then(function (doc) {
          var card = doc.querySelector('.tf-feature__card');
          if (card) slot.replaceWith(adoptCard(card)); else slot.remove();
        }).catch(function () { slot.__tfLoading = false; });
      });
    }

    // Deferred nav images (hosted-trip cards ship without src so crawlers
    // don't attribute them to every page they appear on); hydrate on the
    // first interaction with the header.
    function hydrateNavImages() {
      navImagesHydrated = true;
      root.querySelectorAll('img[data-tf-src]').forEach(function (img) {
        img.src = img.getAttribute('data-tf-src');
        img.removeAttribute('data-tf-src');
      });
    }
    ['pointerover', 'touchstart', 'focusin'].forEach(function (evt) {
      root.addEventListener(evt, hydrateNavImages, { once: true, passive: true });
      root.addEventListener(evt, function () { loadPanels(); }, { once: true, passive: true });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    // ---- Self-contained predictive search (reliable; supersedes the theme SearchBar) ----
    (function () {
      var wrap = root.querySelector('[data-tf-search]');
      if (!wrap) return;
      var form = wrap.querySelector('.tf-search');
      var input = wrap.querySelector('input[name="q"]');
      var results = wrap.querySelector('.search-bar__results');
      var inner = wrap.querySelector('.search-bar__results-inner');
      if (!form || !input || !results || !inner) return;

      var timer = null, last = '', predictive = true;
      try { predictive = !!JSON.parse(document.getElementById('shopify-features').innerHTML).predictiveSearch; } catch (_) {}
      function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

      var popular = wrap.querySelector('[data-tf-popular]');
      var quickMenu = wrap.querySelector('.tf-search__menu');
      function showEmptyState(show) {
        var v = show ? 'false' : 'true';
        if (show && popular) hydrateLazyPicks(popular);
        if (popular) popular.setAttribute('aria-hidden', v);
        if (quickMenu) quickMenu.setAttribute('aria-hidden', v);
        // showing the empty-state suggestions hides the (empty) results
        // container so its padding can't push the suggestions down the card
        results.setAttribute('aria-hidden', show ? 'true' : 'false');
      }
      function hasEmptyState() { return !!(popular || quickMenu); }

      function open() { wrap.classList.add('tf-open'); }
      function close() {
        wrap.classList.remove('tf-open');
        form.classList.remove('is-loading');
        results.setAttribute('aria-hidden', 'true');
        if (popular) popular.setAttribute('aria-hidden', 'true');
        if (quickMenu) quickMenu.setAttribute('aria-hidden', 'true');
      }

      function render(html) {
        var box = document.createElement('div');
        box.innerHTML = (html || '').trim();
        var viewAll = box.querySelector('.search-bar__view-all');
        if (viewAll) box.insertAdjacentElement('beforeend', viewAll);
        inner.innerHTML = box.innerHTML;
      }

      function fetchResults(q) {
        form.classList.add('is-loading');
        open();
        var base = rootUrl() + 'search' + (predictive ? '/suggest' : '');
        var url = base + '?section_id=predictive-search&q=' + encodeURIComponent(q) +
                  '&resources[limit]=4&resources[limit_scope]=each' +
                  '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
        fetch(url, { method: 'GET', credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (text) {
            if (q !== last) return; // ignore stale responses
            var tmp = document.createElement('div');
            tmp.innerHTML = text;
            var ajax = tmp.querySelector('.search-ajax');
            form.classList.remove('is-loading');
            render(ajax ? ajax.innerHTML : '');
          })
          .catch(function () { form.classList.remove('is-loading'); });
      }

      function onInput() {
        var q = input.value.trim();
        last = q;
        if (!q) {
          inner.innerHTML = '';
          if (hasEmptyState()) { form.classList.remove('is-loading'); showEmptyState(true); open(); }
          else close();
          return;
        }
        showEmptyState(false);
        clearTimeout(timer);
        timer = setTimeout(function () { fetchResults(q); }, 200);
      }
      function onFocus() {
        var q = input.value.trim();
        if (q && inner.innerHTML.trim()) { showEmptyState(false); open(); }
        else if (!q && hasEmptyState()) { showEmptyState(true); open(); }
      }

      // Block the theme SearchBar's handlers (capture phase = independent of init order)
      input.addEventListener('input', function (e) { e.stopImmediatePropagation(); onInput(); }, true);
      input.addEventListener('focusin', function (e) { e.stopImmediatePropagation(); onFocus(); }, true);
      form.addEventListener('submit', function (e) { e.stopImmediatePropagation(); }, true); // native submit to /search still fires

      var clearBtn = wrap.querySelector('[data-tf-clear]');
      if (clearBtn) clearBtn.addEventListener('click', function () {
        input.value = ''; last = ''; inner.innerHTML = '';
        // clicking the X clears the field AND closes the dropdown; blur so the
        // focus handler doesn't immediately reopen the empty-state suggestions
        close();
        input.blur();
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
    })();

    // Cart bubble: hidden at 0. The theme updates the count text client-side,
    // so watch it and re-toggle.
    (function () {
      var cartCount = root.querySelector('.tf-cart__count');
      if (!cartCount) return;
      function syncCartBubble() {
        var n = parseInt(cartCount.textContent, 10) || 0;
        cartCount.classList.toggle('is-empty', n === 0);
      }
      new MutationObserver(syncCartBubble).observe(cartCount, { childList: true, characterData: true, subtree: true });
      syncCartBubble();
    })();

    // Smart sticky: header scrolls away going down, slides back in after the
    // user scrolls UP by more than REVEAL_BUFFER px (and hides again after the
    // same buffer of downward scroll). Condensed (no utility bar) while pinned mid-page.
    var sectionEl = root.closest('section[data-section-settings]');
    var sectionCfg = {};
    try { sectionCfg = JSON.parse(sectionEl ? sectionEl.dataset.sectionSettings : '{}'); } catch (_) {}
    if (sectionCfg.useStickyHeader) {
      // Hybrid: slide the whole header group (links bar + classic header +
      // nav row) via the #tf-header-stack layout wrapper; full mode moves
      // just this section.
      var hybridStack = root.classList.contains('tf-header--hybrid') ? document.getElementById('tf-header-stack') : null;
      var stickyWrap = hybridStack || root.closest('.shopify-section') || sectionEl || root;
      var REVEAL_BUFFER = 50;
      var ticking = false;
      var lastY = window.scrollY;
      var upDist = 0, downDist = 0;
      var revealed = false;

      function update() {
        var el = stickyWrap;
        var y = Math.max(0, window.scrollY);
        var h = el.offsetHeight || 120;

        if (y > lastY) {
          downDist += y - lastY; upDist = 0;
          if (revealed && downDist > REVEAL_BUFFER) {
            revealed = false;
            el.classList.add('tf-anim'); // animate the slide back out
          }
        } else if (y < lastY) {
          upDist += lastY - y; downDist = 0;
          if (!revealed && y > h + 60 && upDist > REVEAL_BUFFER) {
            revealed = true;
            el.classList.add('tf-anim'); // animate the slide in
            root.classList.add('is-condensed');
          }
        }
        lastY = y;
        // Only release states at the absolute top: scroll anchoring is
        // suppressed at scroll position 0, so the promo/utility bars
        // reappearing there can't shift the scroll position and bounce.
        // The header is at its natural position there anyway, so the
        // un-animated top change is invisible.
        if (y <= 1) {
          revealed = false;
          el.classList.remove('tf-anim');
          root.classList.remove('is-condensed');
        }
        // Parked top = -(own height): scrolling near the top moves the header
        // in/out natively (its flow position wins over the sticky constraint),
        // and mid-page it sits hidden just above the viewport until revealed.
        el.style.top = revealed ? '0px' : -(h + 12) + 'px';
        // Keep the theme's header vars in sync so other sticky UI (mobile
        // collection toolbar, sticky product cards) offsets itself below the
        // revealed header instead of being covered by it.
        var docStyle = document.documentElement.style;
        docStyle.setProperty('--header-height', h + 'px');
        docStyle.setProperty('--header-is-sticky', revealed ? '1' : '0');
        // How many px of header actually cover the top of the viewport right
        // now: the full height while revealed, and near the top of the page
        // whatever has not scrolled off yet (flow position beats the parked
        // sticky top there). Page-level floating chrome — the travel trip nav
        // in sections/trip-sticky-nav.liquid — docks against this so it sits
        // below the header instead of burying it.
        docStyle.setProperty('--tf-header-offset', (revealed ? h : Math.max(0, h - y)) + 'px');
      }
      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function () { update(); ticking = false; });
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      update(); // set initial state if page loads mid-scroll
    }
  }

  function boot() {
    document.querySelectorAll('[data-tf-header]').forEach(initTridentHeader);
  }

  // The header markup precedes this inline script, so its DOM is already
  // parsed — boot immediately rather than waiting for DOMContentLoaded,
  // which heavy pages delay for seconds (dead hamburger during load).
  // initTridentHeader is idempotent, so the fallback re-run is a no-op.
  boot();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }
  // Theme editor: re-init when this section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-tf-header]');
    if (r) { r.__tfInit = false; initTridentHeader(r); }
  });
})();

// Video lightbox — guards against re-definition on collection pages that already define these
if (typeof window.openCollectionVideo !== 'function') {
  window.openCollectionVideo = function (videoId) {
    var modal = document.getElementById('collection-video-modal-' + videoId);
    var container = document.getElementById('collection-video-container-' + videoId);
    if (modal && container) {
      if (!container.querySelector('iframe')) {
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
        iframe.style.cssText = 'width:100%;height:100%;border:none;';
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        container.appendChild(iframe);
      }
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  };
  window.closeCollectionVideo = function (videoId) {
    var modal = document.getElementById('collection-video-modal-' + videoId);
    var container = document.getElementById('collection-video-container-' + videoId);
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      if (container) container.innerHTML = '';
    }
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.collection-video-modal[style*="flex"]').forEach(function (m) {
        window.closeCollectionVideo(m.id.replace('collection-video-modal-', ''));
      });
    }
  });
}
